<!-- Edit Question Dialog -->
<app-applicant-interview-question-dialog
    *ngIf="interviewQuestionToEdit"
    [interviewQuestion]="interviewQuestionToEdit"
    [openDialog]="openQuestionDialog"
    [editMode]="true"
    (closeApplicantInterviewQuestionDialog)="closeInterviewQuestionDialog()"
    (addApplicantInterviewQuestion)="editInterviewQuestion($event)"
></app-applicant-interview-question-dialog>

<!-- Delete Confirmation Dialog -->
<ui-dialog
    [open]="isDeleteInterviewQuestionDialogOpen"
    (closing)="closeDeleteInterviewQuestionDialog()"
    header="applicant-tracker.deleteQuestion"
>
    <p>
        {{
            'applicant-tracker.messages.interview.areYouSureYouWantToDeleteTheQuestion'
                | translate: { question: interviewQuestionToEdit?.question }
        }}
    </p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeDeleteInterviewQuestionDialog()">{{ 'cancel' | appTranslate }}</ui-button>
        <ui-button type="danger" (click)="deleteInterviewQuestion()">{{ 'delete' | appTranslate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ng-container *ngIf="interviewQuestions.length > 0">
    <div cdkDropList (cdkDropListDropped)="drop($event)" role="list">
        <ui-card
            *ngFor="let interviewQuestion of interviewQuestions; let index = index"
            class="interview-question-card"
            role="listitem"
            [attr.aria-label]="interviewQuestion.question"
            cdkDrag
        >
            <div class="flex align-items-center">
                <mat-icon class="drag-icon" svgIcon="dragAndDrop"></mat-icon>
                <div class="margin-left-1 question">{{ interviewQuestion.question }}</div>
                <div class="questions-card-menu">
                    <ui-button [attr.name]="'questionIndex-' + index" [matMenu]="meatball" size="no-padding">
                        <div class="sr-only">
                            {{ interviewQuestion.question }} {{ 'screen-reader-only.moreActions' | translate }}
                        </div>
                        <mat-icon class="edit-icon" svgIcon="meatballHorizontal"></mat-icon>
                    </ui-button>
                    <!-- Mat menu -->
                    <mat-menu #meatball xPosition="after">
                        <button (click)="openEditInterviewQuestionDialog(interviewQuestion)" mat-menu-item>
                            {{ 'edit' | appTranslate }}
                        </button>
                        <button (click)="openDeleteInterviewQuestionDialog(interviewQuestion)" mat-menu-item>
                            {{ 'delete' | appTranslate }}
                        </button>
                    </mat-menu>
                </div>
            </div>
            <div class="flex">
                <div class="margin-left-3 question-type">
                    {{ interviewQuestion.interviewQuestionType?.name | appTranslateOptions: InterviewQuestionDisplay
                    }}<ng-container *ngIf="interviewQuestion.questionTypeMode"
                        >,
                        {{
                            interviewQuestion.questionTypeMode | appTranslateOptions: InterviewQuestionTypeModeDisplay
                        }}</ng-container
                    >
                </div>
                <div class="question-type is-required">
                    {{
                        (interviewQuestion.isRequired ? 'applicant-tracker.required' : 'applicant-tracker.optional')
                            | appTranslate
                    }}
                </div>
            </div>
        </ui-card>
    </div>
</ng-container>
